import React, { Component } from "react";
// import TagManager from 'react-gtm-module';

import Columns from "../childrens/columns/.mixins/index";
import CustomToolbar from "../childrens/customToolbar/.mixins";
import GrupoOpcoes from "../childrens/listaConfGrupoFornecedor/listaConfGrupoFornecedor";
import { Helmet } from "react-helmet";

import Cookies from "universal-cookie";
import Alerta from "../../../../../util/snackbars/.mixins/";
import OpcoesRecebimentoGrupoFornecedorController from "../../../../../../controllers/opcoesRecebimentoGrupoFornecedor";

import Config from "../../../../../../controllers/config";
import Log from "../../../../../../controllers/log";

export default class OpcoesRecebimentoGrupoFornecedor extends Component {
    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.state = {
            itens: [],
            itensTable: [],
            title: "Fornecedores ativos no Grupo",
            columns: Columns,
            customToolbar: null,
            pagination: true,
            isLoading: true,
            isError: false,
            error: null,
            ListaVaziaTitle: "Adicione fornecedores ao grupo",
            ListaVaziaText: "Adicione ou remova fornecedores clicando em editar",
        };
        this.setState = this.setState.bind(this);
        this.handleAdicionar = this.handleAdicionar.bind(this);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-conf-grupo-fornecedor',
        //     }
        // });
    }

    UNSAFE_componentWillMount() {
        //carregamento de dados nos campos
        this.loadData(this);
        this.setState({
            customToolbar: () => <CustomToolbar {...this} />,
        });
    }

    handleAdicionar() {
        this.props.router.push(`fornecedoresGrupo-ae/${this.props.params.id}`);
    }

    async loadData(props) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        const filters = {
            idOrg: this.props.params.id,
            inOrg: "S",
        };
        try {
            this.setState({ isLoading: true });
            const r_grupos =
                await OpcoesRecebimentoGrupoFornecedorController.getAllFornecedoresGrupo(
                    token,
                    filters
                );
            const j_r_grupos = JSON.parse(r_grupos.body);
            const arrayItens = j_r_grupos.map((e) => {
                return { ...e };
            });
            if (r_grupos.res.statusCode == 200) {
                props.setState({
                    itensTable: arrayItens,
                    isLoading: false,
                });
            } else {

                if (
                    j_r_grupos.status == false &&
                    j_r_grupos.message &&
                    j_r_grupos.message.includes("Token inválido!") &&
                    props.child.current != null
                ) {
                    props.child.current.retorno("Autentificação inválida!", "error");
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
            //       eventAction: 'callback',
            //       eventLabel: `sucesso:lista-grupos-fornecedores`,
            //     }
            // });

            //auditoria
            const str = `Efetuada requisição para recuperação de dados de Grupo fornecedores opções recebimento! 
            Response:( Method: ${r_grupos.res.request.method}
            , StatusCode: ${r_grupos.res.statusCode}
            , Body: (limited 100chars)${r_grupos.body.substr(0, 100)})`;
            Log.info(token, str);
        } catch (error) {
            if (props.child.current != null) {
                props.child.current.retorno(
                    "Erro ao carregar dados Grupo fornecedores opções recebimento!",
                    "error"
                );
            }
            let errorString = "Erro ao carregar dados Grupo fornecedores opções recebimento!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:conf-grupo-fornecedor',
            //       eventAction: 'callback:loadData',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            const str = `Erro na recuperação de dados de Grupo fornecedores opções recebimento!
            Error:( Message: ${error.message} Stack: ${error.stack} )`;
            Log.error(token, str);
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} -  Grupo fornecedores opções recebimento`}</title>
                </Helmet>
                <GrupoOpcoes {...this} />
                <Alerta ref={this.child} />
            </div>
        );
    }
}
